import script from "./RequestSent.vue?vue&type=script&setup=true&lang=ts"
export * from "./RequestSent.vue?vue&type=script&setup=true&lang=ts"

import "./RequestSent.vue?vue&type=style&index=0&id=5f19a64c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\WebstormProjects\\wisevet-live\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f19a64c"]])

export default __exports__